import { render, staticRenderFns } from "./admin-log.vue?vue&type=template&id=7bd10a81"
import script from "./admin-log.vue?vue&type=script&lang=js"
export * from "./admin-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports